/* WhatsApp nativo: botón "Comprar por WhatsApp", widget flotante y medición de clics.
   Config en window.TWA (snippets/whatsapp-config.liquid). Delegación de eventos: funciona también
   con el formulario clonado por <floated-form>. */
(function () {
  const C = window.TWA || {};
  const money = (cents) => '$' + (Number(cents) / 100).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const waUrl = (text) => 'https://wa.me/' + C.phone + '?text=' + encodeURIComponent(text);

  function track(label, url) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'whatssap', { send_to: C.ga, link_text: label, link_url: url, page_location: location.href });
        window.gtag('event', 'conversion', { send_to: C.aw });
      }
      (window.dataLayer = window.dataLayer || []).push({ event: 'whatsapp_click', whatsapp_label: label });
      if (typeof window.fbq === 'function') window.fbq('track', 'Contact');
    } catch (e) { /* la medición nunca debe impedir abrir WhatsApp */ }
  }

  function variants(el) {
    return (el.dataset.variants || '').split('^').filter(Boolean).map((s) => {
      const [id, price, title, available] = s.split('~');
      return { id, price, title, available: available === 'true' };
    });
  }

  function buyMessage(btn) {
    const box = btn.closest('[data-wa-product]');
    const scope = btn.closest('floated-form, .floated-form, product-info, section, .product') || document;
    const vs = variants(box);
    const idInput = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const urlVariant = new URLSearchParams(location.search).get('variant');
    const vid = (idInput && idInput.value) || urlVariant;
    const v = vs.find((x) => x.id === String(vid)) || vs[0] || {};
    const qInput = scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    const qty = Math.max(1, parseInt(qInput && qInput.value, 10) || 1);
    const link = C.origin + box.dataset.url + (v.id ? '?variant=' + v.id : '');
    const lines = ['Hola ' + C.shop + ', quiero comprar:', '', '• Producto: ' + box.dataset.title];
    if (v.title && v.title !== 'Default Title') lines.push('• Opción: ' + v.title);
    lines.push('• Cantidad: ' + qty);
    if (v.price) {
      lines.push('• Precio: ' + money(v.price) + ' c/u (pago en divisas)');
      if (qty > 1) lines.push('• Total: ' + money(v.price * qty));
    }
    lines.push('• Enlace: ' + link, '', v.available === false ? '¿Cuándo vuelve a estar disponible?' : '¿Me confirman disponibilidad y envío?');
    return lines.join('\n');
  }

  function chatMessage(widget) {
    if (widget && widget.dataset.title) return 'Hola ' + C.shop + ', tengo una consulta sobre: ' + widget.dataset.title + '\n' + C.origin + widget.dataset.url;
    return 'Hola ' + C.shop + ', tengo una consulta.';
  }

  const TRACKED_TEXT = /agendar cita|cont[aá]ctanos/i;

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-wa-toggle]');
    const close = e.target.closest('[data-wa-close]');
    if (toggle || close) {
      const w = (toggle || close).closest('[data-wa-widget]');
      const panel = w.querySelector('.wa-widget__panel');
      const open = toggle ? panel.hidden : false;
      panel.hidden = !open;
      w.querySelector('[data-wa-toggle]').setAttribute('aria-expanded', String(open));
      return;
    }
    const a = e.target.closest('a');
    if (!a) return;
    const kind = a.dataset.wa;
    if (kind === 'buy') a.href = waUrl(buyMessage(a));
    else if (kind === 'chat') a.href = waUrl(chatMessage(a.closest('[data-wa-widget]')));
    const href = a.href || '';
    const isWa = /wa\.me|api\.whatsapp\.com|whatsapp:/i.test(href);
    if (isWa || TRACKED_TEXT.test(a.textContent || '')) {
      track(kind === 'buy' ? 'Comprar por WhatsApp' : kind === 'chat' ? 'Widget WhatsApp' : (a.textContent || '').trim().slice(0, 60), href);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-wa-widget] .wa-widget__panel:not([hidden])').forEach((p) => {
      p.hidden = true;
      p.closest('[data-wa-widget]').querySelector('[data-wa-toggle]').setAttribute('aria-expanded', 'false');
    });
  });
})();
